import React, { ComponentProps, FC, memo } from 'react'

import dayjs from 'dayjs'

import { Txt, FontSizeType } from 'src/components/atoms'

type Props = {
  sizeType?: FontSizeType
  date: Date
  withTime?: boolean
  format?: string
  tag?: ComponentProps<typeof Txt>['tag']
  className?: string
}

export const DateTxt: FC<Props> = memo(
  ({ sizeType, date, withTime = false, format, tag, className }) => {
    const f = format || (withTime ? 'YYYY/MM/DD HH:mm' : 'YY/MM/DD')
    const formatDate = dayjs(date).format(f)

    return (
      <Txt sizeType={sizeType} className={className} tag={tag}>
        {formatDate}
      </Txt>
    )
  }
)
